import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SimulationDto')
export class SimulationDto {
  @JsonProperty('referenceSimulation', String, true)
  public simulationReference = '';

  @JsonProperty('montantProjet', Number, true)
  public loanAmount = 0;

  @JsonProperty('dureeProjet', Number, true)
  public loanDuration = 0;

  @JsonProperty('mensualiteProjetSansAssurance', Number, true)
  public monthlyPaymentExcludingInsurance = 0;

  @JsonProperty('tnc', Number, true)
  public tnc = 0;

  @JsonProperty('taeg', Number, true)
  public annualPercentageRateOfCharge = 0;

  @JsonProperty('montantInterets', Number, true)
  public interests = 0;

  @JsonProperty('montantFraisDossier', Number, true)
  public applicationFees = 0;

  @JsonProperty('montantTotalDu', Number, true)
  public totalAmount = 0;

  @JsonProperty('montantContreProposition', Number, true)
  public counterProposalAmount = 0;

  @JsonProperty('indicateurEligibilitePret', String, true)
  public isLoanEligible = '';

  @JsonProperty('simulationPreconise', Boolean, true)
  public isRecommendedSimulation = false;

  @JsonProperty('offrePromotionnelle', Boolean, true)
  public isPromotionalOffer = false;

  @JsonProperty('idMessage1', String, true)
  public messageId1 = '';

  @JsonProperty('libelleMessage1', String, true)
  public messageLabel1 = '';

  @JsonProperty('idMessage2', String, true)
  public messageId2 = '';

  @JsonProperty('libelleMessage2', String, true)
  public messageLabel2 = '';

  @JsonProperty('idMessage3', String, true)
  public messageId3 = '';

  @JsonProperty('libelleMessage3', String, true)
  public messageLabel3 = '';
}
